<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit" v-if="resource">
            <header>
                <figure>
                    <i v-if="!resource.picture" class="icon icon-icon_person"></i>
                    <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                </figure>
                <div>
                    <span class="breadcrumb">
                        Profile <i class="icon icon-icon_arrow-right"></i> Edit
                    </span>
                    <h1>{{ resource.firstname ? resource.firstname + " " + resource.lastname : 'Nouveau' }}</h1>

                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>

            <languages :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

            <tabs :options="{ useUrlFragment: false }">
                <tab name="Information">

                    <form-scopes label='Scopes' v-model="resource"></form-scopes>

                    <form-file label='Image' v-model="resource.picture_id" width="200"></form-file>

                    <form-text label="Prénom" v-model="resource.firstname" required="true"></form-text>

                    <form-text label="Nom" v-model="resource.lastname" required="true"></form-text>

                    <form-select label="Companies" multiple="true" v-model="resource.companies" id="id" :options="companies" v-if="companies"></form-select>

                    <component-attributes v-model="resource" :locale="locale"></component-attributes>

                </tab>
                <tab name="Adresses">

                    <component-address v-model="resource.addresses"></component-address>

                </tab>
                <tab name="Authentification">

                    <div v-if="resource.user">

                        <form-text label="Username" v-model="resource.user.email"></form-text>

                        <form-password label="Mot de passe" v-model="resource.user.password"></form-password>

                        <div class="form-field form-checkbox">
                            <div class="form-label">
                                <label></label>
                            </div>
                            <div class="form-input">
                                <div class="form-input-wrapper">
                                    <label>
                                        <input type="checkbox" value="1" v-model="resource.user.active"/>
                                        <strong>Enable account login</strong>
                                        <p>Lorem ipsum dolor sit amet</p>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <form-select label="Scopes" multiple="true" v-model="resource.user.scopes" id="id" :options="scopes" v-if="scopes" :callback="updateRole"></form-select>

                        <div class="form-field form-roles">
                            <div class="form-label">
                                <label>Roles</label>
                            </div>
                            <div class="form-input">
                                <div class="form-input-wrapper">
                                    <div v-for="scope in resource.user.scopes">
                                        <div class="image">
                                            <label class="label scope" v-bind:style="{background:scope.color}">{{ scope.slug.substr(0,1) }}</label>
                                        </div>
                                        <div class="name">{{ scope.name }}</div>
                                        <div>
                                            <label v-for="role in roles"><input type="radio" :value="role.id" :name="'group_'+scope.id" v-model="scope.role_id"/> {{ role.label }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button @click="noAccount()" class="bt-primary"><span>Désactiver le compte</span></button>

                    </div>

                    <div class="activate-option" v-if="!resource.user">
                        <i class="icon icon-icon_lock"></i>
                        <h2>Activer l'authentification de ce compte</h2>
                        <button @click="createAccount()" class="bt-primary"><span>Activer</span></button>
                    </div>

                </tab>
            </tabs>

            <footer>
            </footer>
        </article>
    </div>
</template>
<script>


    import PersonService from './PersonService.js';
    import ScopeService from '../scope/ScopeService.js';
    import CompanyService from '../company/CompanyService.js';

    import ComponentAddress from "../../components/Address.vue";
    import ComponentAttributes from "../../components/Attributes.vue";

    import Edit from '../../layouts/Edit.vue';

    export default {
        extends: Edit,
        components: {
            'component-address': ComponentAddress,
            'component-attributes': ComponentAttributes,
        },
        data () {
            return {
                attributes: [],
                resource: {
                    addressable: [],
                    companies: [],
                    user: {
                        workspaces: []
                    }
                },
                options: [],
                companies: [],
                scopes: [],
                roles: [
                    {id: 1, label: 'Superadmin'},
                    {id: 2, label: 'Administrator'},
                    {id: 3, label: 'Moderator'},
                    {id: 4, label: 'User'}
                ],
                isLoading: false
            }
        },
        mounted: function(){
            ScopeService.query().then(response => {
                this.scopes = response.data.data
                this.isLoading = false
            })
            CompanyService.query().then(response => {
                this.companies = response.data.data
                this.isLoading = false
            })
        },
        methods:{
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.updateRole()
            },
            beforeUpdate: function(){
                this.resource.user = this.resource.user && this.resource.user.email ? this.resource.user : null
                return true
            },
            getResource: function(){
                return {name: 'person', api: PersonService}
            },
            createAccount(){
                this.resource.user = {
                    email: "",
                    password: "",
                    workspaces: []
                }
            },
            noAccount(){
                this.resource.user = null
            },
            updateRole(){
                for(let item of this.resource.user.scopes){
                    let roleId = 4;
                    for(let role of this.resource.user.role_scopes){
                        if( item.id == role.scope_id ){
                            roleId = role.role_id;
                            //console.log("Role setted to", role.role_id);
                        }
                    }
                    item.role_id = roleId;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/person/Edit.vue